"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DestinationLabelCaptionItem = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const styled_components_1 = __importDefault(require("styled-components"));
exports.DestinationLabelCaptionItem = styled_components_1.default.span(({ theme: { colors, space } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    flexGrow: 1,
    textAlign: 'right',
    color: colors.secondary,
    paddingLeft: space[2],
}));
//# sourceMappingURL=fdr-travel-destination-label-caption.styles.js.map